var map = {
	".": "+hJF",
	"./": "+hJF",
	"./00_limit": "u2Il",
	"./00_limit.json": "u2Il",
	"./01_connect": "uUP9",
	"./01_connect.json": "uUP9",
	"./02_data_compress": "ku8a",
	"./02_data_compress.json": "ku8a",
	"./03_heart_beat": "QDPd",
	"./03_heart_beat.json": "QDPd",
	"./04_subscribe": "f4mz",
	"./04_subscribe.json": "f4mz",
	"./05_cancel_subscribe": "IhWV",
	"./05_cancel_subscribe.json": "IhWV",
	"./index": "+hJF",
	"./index.js": "+hJF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "O2Id";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/websocket/introduce ^.*$
// module id = O2Id
// module chunks = 3